import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Loading, SharingTables } from '../root/components/common'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { cloneDeep } from 'lodash'
import * as actions from './actions'
import { Table } from '../root/components/common/table'

const useStyles = makeStyles(theme => ({
    wrapper: {
        height: '100%'
    },
    noItemsWrapper: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    link: {
        fontWeight: 'bold',
        cursor: 'pointer'
    },
    tableInfo: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
    }
}))

function ChooseLocations(props){
    const classes = useStyles()
    const dispatch = useDispatch()

    const { isLoading, locale } = useSelector(state => state.main)
    const { locations, selectedLocations } = useSelector(state => state.sharing)
    const [checkedInitialLocations, setCheckedInitialLocations] = useState({})
    const [checkedSelectedLocations, setCheckedSelectedLocations] = useState({})
    const [locationsMutable, setLocationsMutable] = useState(locations ? cloneDeep(locations) : [])
    const [selectedLocationsMutable, setSelectedLocationsMutable] = useState(cloneDeep(selectedLocations))

    const columns = [
        {
            key: 'name',
            label: locale.common.name,
            sortable: true,
            dataType: 'string',
            useCustomRenderer: false
        },
        {
            key: 'customer_name',
            label: locale.common.organisation,
            sortable: true,
            dataType: 'string',
            useCustomRenderer: false
        },
        {
            key: 'address',
            label: locale.sharing.address,
            sortable: true,
            dataType: 'string',
            useCustomRenderer: false
        }
    ]

    const setLocationsState = (data) => {
        dispatch(actions.locationsRequestSuccess(data))
        setCheckedInitialLocations({})
        setCheckedSelectedLocations({})
    }

    const setSelectedLocationsState = (data) => {
        dispatch(actions.setSelectedLocations(data))
        setCheckedInitialLocations({})
        setCheckedSelectedLocations({})
    }

    useEffect(() => {
        setLocationsMutable(cloneDeep(locations))
        setSelectedLocationsMutable(cloneDeep(selectedLocations))
    }, [locations, selectedLocations])

    return (
        <div className={classes.wrapper}>
            {isLoading &&
                <Loading/>
            }
            {!isLoading &&
                <React.Fragment>
                    {(!locationsMutable || locationsMutable.length === 0) && (!selectedLocationsMutable || selectedLocationsMutable.length === 0) &&
                        <div className={classes.noItemsWrapper}>
                            <div>
                                {locale.sharing.noLocationsToShare}
                            </div>
                            <div>
                                {locale.sharing.contactSupport}
                            </div>
                        </div>
                    }
                    {((locationsMutable && locationsMutable.length > 0) || selectedLocationsMutable && selectedLocationsMutable.length > 0) &&
                        <SharingTables
                            leftData={locationsMutable}
                            rightData={selectedLocationsMutable}
                            selectedLeftData={checkedInitialLocations}
                            selectedRightData={checkedSelectedLocations}
                            uniqueKey='id'
                            setLeftData={setLocationsState}
                            setRightData={setSelectedLocationsState}
                            leftTable={
                                (locationsMutable && locationsMutable.length > 0)
                                ? (
                                    <Table
                                        rows={locationsMutable}
                                        columns={columns}
                                        multiselect
                                        selected={checkedInitialLocations}
                                        select={setCheckedInitialLocations}
                                    />
                                )
                                : (
                                    <div className={classes.tableInfo}>
                                        {locale.sharing.noLocationsLeft}
                                    </div>
                                )
                            }
                            rightTable={
                                (selectedLocationsMutable && selectedLocationsMutable.length > 0)
                                ? (
                                    <Table
                                        rows={selectedLocationsMutable}
                                        columns={columns}
                                        multiselect
                                        selected={checkedSelectedLocations}
                                        select={setCheckedSelectedLocations}
                                    />
                                )
                                : (
                                    <div className={classes.tableInfo}>
                                        {locale.sharing.noLocationsSelected}
                                    </div>
                                )
                            }
                        />
                    }
                </React.Fragment>
            }
        </div>
    )
}

export default withRouter(ChooseLocations)
